<script>
let playBtns, presentTime, totalTime, audio, curProgrees, progrees, progreesBox, animationBox;
export default {
    data() {
        return {
            isFirstPlay: true,
            isOver: false,
            progressTimer: null,
            timeTimer: null,
            play_icon: require("@/assets/img/audio/play_icon.png"),
            stop_icon: require("@/assets/img/audio/stop_icon.png"),
            showPopover: false,
            audioSpeed: 1,
            audioSpeedText: '',
            actions: [
                {text: '0.8x', val: 0.8}, {text: '正常', val: 1.0}, {text: '1.2x', val: 1.2}
            ]
        }
    },
    props: ['audio_url', 'title', 'name', 'pic', 'flag'],
    mounted() {
        console.log(this.play_icon, this.stop_icon);
        presentTime = document.getElementById("audio-this-time"); //当前时长
        totalTime = document.getElementById("audio-count-time"); //歌曲总时长
        audio = document.getElementById("audio"); //播放器
        curProgrees = document.getElementById("audio-cache-setbacks"); //已经播放进度条
        progrees = document.getElementById("progrees"); //播放进度条
        progreesBox = document.getElementById("audio-cache-box");
        animationBox = document.getElementById("animationBox");

        audio.__loadedmetadata = (e) => {
            this.setTime(e.target.duration, totalTime);
        }

        audio.addEventListener("loadedmetadata", audio.__loadedmetadata)

        audio.addEventListener("pause", this.onAudioPause);
        audio.addEventListener("play", this.onAudioPlay);

        progrees.__mousedown = (e) => {
            //判断音乐是否在正常播放
            if (!audio.paused || audio.currentTime !== 0) {
                let pgsWidth = progrees.offsetWidth;
                let rate = e.offsetX / pgsWidth;
                audio.currentTime = audio.duration * rate;
            }
        }

        progrees.addEventListener("mousedown", progrees.__mousedown);
    },
    beforeDestroy() {
        clearInterval(this.timeTimer);
        clearInterval(this.progressTimer);
        audio.removeEventListener("loadedmetadata", audio.__loadedmetadata);
        progrees.removeEventListener("mousedown", progrees.__mousedown);
        audio.removeEventListener("pause", this.onAudioPause);
        audio.removeEventListener("play", this.onAudioPlay);
    },
    methods: {
        resetPlay() {
            this.stopPlay();
            this.play();
        },
        setSpeed() {
            audio.playbackRate = this.audioSpeed;
        },
        onSelect(e) {
            this.audioSpeed = e.val;
            this.audioSpeedText = this.audioSpeed === 1 ? '' : e.text;
            this.setSpeed();
        },
        getPlay() {
            this.$nextTick(() => {
                if (this.flag) {
                    this.pause();
                } else {
                    this.play();
                }
            })
        },
        // 原生 play/pause 事件回调：只同步状态，不能再调用 audio.play()/audio.pause()，
        // 否则“重听”时 pause 事件与 play 事件会互相触发，形成死循环
        onAudioPlay() {
            this.$emit("on-play-status-change", true);
        },
        onAudioPause() {
            this.$emit("on-play-status-change", false);
        },
        play() {
            this.$emit("on-play-status-change", true);
            this.$nextTick(() => {
                console.log("play flag", this.flag);
                this.isOver = false;
                // if (this.isFirstPlay) {
                //     let storage = localStorage.getItem('audio-current-time') || null;
                //     if (storage) {
                //         let obj = JSON.parse(storage);
                //         if (obj.url === this.audio_url) {
                //             this.$toast("获取到缓存" + storage);
                //             audio.currentTime = Number(obj.currentTime);
                //         }
                //     }
                // }
                audio.play();
                this.playProgress();
                this.playTime();
                // this.isFirstPlay = false;
            })
        },
        pause() {
            this.$emit("on-play-status-change", false);
            this.$nextTick(() => {
                audio.pause();
            })
        },
        stopPlay() {
            this.$emit("on-play-status-change", false);
            this.isOver = true;
            audio.pause();
            audio.currentTime = 0;
            curProgrees.style.width = '0px';
            progreesBox.style.left = '-0.2rem';
        },
        playTime() {
            if (this.flag) {
                clearInterval(this.timeTimer);
                this.timeTimer = setInterval(() => {
                    this.setTime(audio.duration, totalTime);
                    this.setTime(audio.currentTime, presentTime);
                    // localStorage.setItem('audio-current-time', JSON.stringify({
                    //     url: this.audio_url,
                    //     currentTime: audio.currentTime
                    // }));
                }, 16.6);
            } else {
                clearInterval(this.timeTimer);
                // localStorage.setItem('audio-current-time', JSON.stringify({
                //     url: this.audio_url,
                //     currentTime: audio.currentTime
                // }));
            }
        },
        setTime(audioTime, obj) {
            let allMinute = Math.floor(audioTime / 60);
            if (allMinute < 10) {
                allMinute = "0" + allMinute;
            }
            let allSecond = Math.floor(audioTime % 60);
            if (allSecond < 10) {
                allSecond = "0" + allSecond;
            }
            let allTime = allMinute + ":" + allSecond;
            obj.innerHTML = allTime;
        },
        playProgress() {
            if (this.flag) {
                clearInterval(this.progressTimer);
                this.progressTimer = setInterval(() => {
                    if (audio.currentTime >= audio.duration) {
                        curProgrees.style.width = progrees.offsetWidth + "px";
                        clearInterval(this.progressTimer);
                        audio.currentTime = 0;
                        this.stopPlay();

                    } else {
                        curProgrees.style.width = (audio.currentTime / audio.duration) * progrees.offsetWidth + "px";
                        progreesBox.style.left = (audio.currentTime / audio.duration) * progrees.offsetWidth - 10 + "px";
                    }
                }, 16.6);
            } else {
                clearInterval(this.progressTimer);
            }
        }
    }
};
</script>

<template>
    <div class="audio-panel bg-gray-600 w-full h-full">
        <div class="audio_main">
            <!--      <div class="audio_title py-3">-->
            <!--        <div class="audio_bt text-base truncate">{{ title }}</div>-->
            <!--      </div>-->
            <div class="audio_main_center">
                <div class="audio_path mb-5">
                    <div id="animationBox" class="audio_bg p-5 w-72 h-72 md:w-48 md:h-48">
                        <div class="audio_img"><img :src="pic" class="object-contain w-full"></div>
                    </div>
                </div>

                <div class="audio_silder px-4">
                    <div class="audio_info mb-5">
                        <div class="audio_info_title text-white text-base mb-1.5 font-bold truncate">{{ title }}</div>
                    </div>
                    <div id="progrees" class="silder audio-setbacks h-1.5">
                        <div id="audio-cache-setbacks" class="silder_color h-1.5"></div>
                        <div id="audio-cache-box" class="silder_box h-3 w-3"></div>
                    </div>
                    <div class="silder_tiem text-sm mb-5">
                        <div id="audio-this-time" class="time_left">00:00</div>
                        <div id="audio-count-time" class="time_right ">00:00</div>
                    </div>
                    <div class="audio_play flex justify-between items-center relative">
                        <div class="reset text-white">
                            <span @click="resetPlay">重听</span>
                        </div>
                        <div id="playBtn" class="item play_stop absolute left-1/2" @click="getPlay" v-if="flag"><span
                            :style="`background-image: url('${stop_icon}')`"></span></div>
                        <div id="playBtn" class="item play_icon absolute left-1/2" @click="getPlay" v-else><span
                            :style="`background-image: url('${play_icon}')`"></span></div>
                        <div class="speed text-white">
                            <van-popover
                                v-model="showPopover"
                                :actions="actions"
                                placement="left-end"
                                trigger="click"
                                @select="onSelect"
                            >
                                <template #reference>
                                    <span> <span v-if="audioSpeedText"
                                                 class="mr-0.5">{{ audioSpeedText }}</span> 倍速</span>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <audio id="audio" :src="audio_url" preload></audio>
    </div>
</template>

<style scoped>

.audio-panel {
    /**
    background-image: radial-gradient(#4e5051, #4e5051, #2e3235);
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    **/
}

.audio_main {
    padding-top: 3rem;
    height: 100%;
}

.audio_title {
    text-align: center;
    padding: 2rem 3rem;
}

.audio_title .audio_bt {
    /**font-size: 16px;**/
    color: #FFF;
    font-weight: bold;
    /**margin-bottom: 5px;**/
}

.audio_title .audio_tag {
    color: #a3a3a3;
}

.audio_main_center {
    display: flex;
    flex-direction: column;
    /**height: calc(100% - 67px);**/
    justify-content: space-around;
}

.audio_path .audio_bg {
    background: #414344;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto;
    object-fit: contain;
}

.audio_path .audio_bg img {
    border-radius: 50%;
    width: 100%;
}

.audio_info .audio_info_tag {
    display: flex;
    color: #a3a3a3;
}

.audio_info .audio_info_tag span {
    display: flex;
    background: #bfe8ff;
    color: #587ccc;
    align-items: center;
    justify-content: center;
}

.audio_silder .silder {
    background: #fff;
    border-radius: 20px;
    width: 100%;
    position: relative;
    margin-bottom: 10px;
}

.audio_silder .silder_color {
    border-radius: 20px;
    background: #20c6a3;
    width: 0;
}

.audio_silder .silder_box {
    border-radius: 50%;
    background: #fff;
    position: absolute;
    top: -0.2rem;
    left: 0;
}

.audio_silder .silder_tiem {
    display: flex;
    justify-content: space-between;
    color: #FFF;
}

.audio_play .play_stop {
    background: #20c6a3;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.audio_play .play_icon {
    background: #20c6a3;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.audio_play .play_icon span {
    display: block;
    /**background: url('@/assets/img/audio/play_icon.png') no-repeat;**/
    background-size: 100%;
    width: 1.6rem;
    height: 1.6rem;
    overflow: hidden;
    margin-left: 0.3rem;
    background-repeat: no-repeat;
}

.audio_play .play_stop span {
    display: block;
    /**background: url('@/assets/img/audio/stop_icon.png') no-repeat;**/
    background-size: 100%;
    width: 1.6rem;
    height: 1.6rem;
    overflow: hidden;
    background-repeat: no-repeat;
}


.audio_play .play_icon img {
    margin-left: 0.3rem;
}

.audio_play img {
    width: 80%;
    height: 80%;
}

#playBtn {
    transform: translateX(-50%);
}

/*动画*/
@keyframes animationName {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
